import { render } from "./BottomListView.vue?vue&type=template&id=75f8b404&scoped=true"
import script from "./BottomListView.vue?vue&type=script&lang=js"
export * from "./BottomListView.vue?vue&type=script&lang=js"

import "./BottomListView.vue?vue&type=style&index=0&id=75f8b404&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f8b404"]])

export default __exports__